// START A/B TEST PPIWEBM-1642: Update Billing CTA in top nav
import { Tooltip, TooltipConfig } from 'components/Tooltip';
import { getLocale } from 'services/LocalizationService';

export class UpdateCTATopNav {
    constructor() {
        this.init();
    }

    init() {
        try {
            if (this.isLocationAllowed()) {
                // setup tooltip and tracking
                this.setupCtaTooltip();
                this.setupTrackingEvents();
            }
        } catch (e) {
            console.error('Error in UpdateCTATopNav', e);
        }
    }

    /**
     * Setup tooltip on update billing cta
     */
    setupCtaTooltip() {
        const tooltipConfig = new TooltipConfig({
            targetSelector: '.updateBillingCTA',
            selectorsList: ['.updateBillingCTA'],
            innerHTML: getLocale('edit_your_payment_method_to_continue_enjoying_paramount_plus'),
            events: ['mouseover', 'focus'],
            position: 'bottom',
        });
        new Tooltip(tooltipConfig);
    }

    isLocationAllowed() {
        return true; // window.location.pathname === '/home/' || window.location.pathname === '/browse/';
    }

    /**
     * Setup/bind cta mouseover and click events to tracking functions
     */
    setupTrackingEvents() {
        const elements = document.getElementsByClassName('updateBillingCTA');

        if (elements.length > 0) {
            const cta = elements[0];
            cta.addEventListener('mouseenter', this.trackCtaMouseenter);
            cta.addEventListener('click', this.trackCtaClick);
        }
    }

    /**
     * Tracking for resume subscription cta click event
     */
    trackCtaClick() {
        const trackingParams = {
            menuItemLabel: 'Update',
            menuOrientation: 'header',
            posRowNum: '0',
            posColNum: '9',
        };
        if (typeof om != 'undefined') {
            om.trackAction('trackMenu', trackingParams);
        }
    }

    /**
     * Tracking for edit billing cta mouse over event
     */
    trackCtaMouseenter() {
        const trackingParams = {
            tooltipType: 'upgrade',
            optimizelyExp: CBS.Tracking?.utag_data?.optimizelyExp ?? '',
            screenName: CBS.Tracking?.utag_data?._pageName ?? '',
        };

        if (typeof om != 'undefined') {
            om.trackAction('trackTooltipView', trackingParams);
        }
    }
}
// END A/B TEST PPIWEBM-1642: Update Billing CTA in top nav
